export const WEBHOOKS_API_BASE_URL = 'ui/partner/webhook';

export const webhooksQueryKeys = {
  all: [WEBHOOKS_API_BASE_URL],
};
